import { H1, Icon, Overlay, Tag } from "@blueprintjs/core"
import React, { useCallback, useEffect, useState } from "react"
import classNames from "classnames"

import cssUtils from "./utilsCss.module.css"
import css from "./NotificationsPermissionsRequest.module.css"
import { toast } from "sonner"
import { Bell, X } from "lucide-react"
import { Button } from "@/components/ui/button"
import i18n from "@/lib/i18n/i18n"
import { useTranslation } from "react-i18next"

function showNotificationRequestToast(onAllowNotification: () => void) {
  toast.custom(
    (toastId) => (
      <div className="flex h-16 w-[527px] max-w-full items-center gap-2 rounded-xl border bg-background p-4 shadow-lg">
        <Bell className="h-5 w-5 text-foreground" />

        <div className="flex-1 text-sm font-medium leading-normal text-popover-foreground">
          {i18n.t("app.notifications.request")}
        </div>
        <Button
          size="sm"
          onClick={() => {
            toast.dismiss(toastId)
            onAllowNotification()
          }}
          className="w-16 bg-blue-600 px-6 text-white hover:bg-blue-700"
        >
          {i18n.t("app.actions.enable")}
        </Button>

        <Button
          onClick={() => toast.dismiss(toastId)}
          variant="outline"
          size="sm"
          className="w-8"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    ),
    {
      duration: Infinity,
    },
  )
}

const WebNotificationsPermissionRequest = () => {
  const { t } = useTranslation()
  const [overlayOpen, setOverlayOpen] = useState(false)

  const closeOverlay = useCallback(() => {
    setOverlayOpen(false)
  }, [])

  useEffect(() => {
    if (!window.Notification) return

    if (window.Notification.permission === "default") {
      const onAllowNotification = () => {
        setOverlayOpen(true)
        window.Notification.requestPermission().then(() => {
          closeOverlay()
        })
      }
      showNotificationRequestToast(onAllowNotification)
    }
  }, [closeOverlay])

  if (!overlayOpen) return <></>
  return (
    <Overlay
      isOpen={overlayOpen}
      enforceFocus={true}
      onClose={closeOverlay}
      canOutsideClickClose={false}
    >
      <div className={classNames(css.container, cssUtils.center)}>
        <div>
          <Icon icon="arrow-top-left" size={48} />
        </div>
        <div className={css.info}>
          <H1>{t("app.notifications.title")}</H1>
          <p>{t("app.notifications.text")}</p>
          <Tag onClick={closeOverlay} interactive large round>
            {t("app.actions.gotIt")}
          </Tag>
        </div>
      </div>
    </Overlay>
  )
}

export default WebNotificationsPermissionRequest
